import { render, staticRenderFns } from "./ordinary_edit.vue?vue&type=template&id=4ea75168&scoped=true&"
import script from "./ordinary_edit.vue?vue&type=script&lang=js&"
export * from "./ordinary_edit.vue?vue&type=script&lang=js&"
import style0 from "./ordinary_edit.vue?vue&type=style&index=0&id=4ea75168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea75168",
  null
  
)

export default component.exports